import React, { useState } from 'react';
import CloseButton from '../../Buttons/CloseButton';
// import './style.scoped.scss';
import '../modals.scss';
import { notification } from '../../../assets/constants/strings';
import { connect } from 'react-redux';
import { CreateComment } from '../../../store/User/userActions';
import AuthLoader from '../../Loader/Auth';

const CommentsModal = ({
  handleDismiss,
  loading,
  CreateComment,
}) => {

  const [value, setValue] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!loading) {
      if (value.replace(/\s|s|S/g, '').length !== 0) {
        CreateComment(value);
        handleDismiss();
        setValue('');
      } else {
        notification('info', 'No information provided', 'Please type something before submitting.');
      }
    }
  }

  return (
    <div className="modal about" id="commentsModal">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h2>Comments and Suggestions</h2>
            <CloseButton title="Dismiss Modal" handleClose={handleDismiss} />
          </div>
          <form onSubmit={handleSubmit} className="modal-body px-3">
            <div className="form-group w-100">
              <label htmlFor="commentsBox">
                Please enter your feedback.
              </label>
              <textarea
                id="commentsBox"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="Start typing..."
                className="form-control"
              />
            </div>
            <button type="submit">Send{loading ? <AuthLoader /> : null}</button>
          </form>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.user.loading,
});

const mapDispatchToProps = { CreateComment };

export default connect(mapStateToProps, mapDispatchToProps)(CommentsModal);
